import React from "react";

export default function App() {
  const [registrationId, setRegistrationId] = React.useState("");
  const [error, setError] = React.useState("");

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");

    const normalizedRegistrationId = registrationId.trim().toUpperCase();

    if (!normalizedRegistrationId) {
      setError("Please enter a registration id.");
      return;
    }

    const certificateUrl = `https://server.elvesonthecloud.com/content/certificates/${encodeURIComponent(normalizedRegistrationId)}.png/`;
    window.open(certificateUrl, "_blank", "noopener,noreferrer");
  };

  return (
    <div className="container" id="certificates">
      <div className="row justify-content-center">
        <div className="col-12 col-md-8 col-lg-6">
          <h5 className="card-title mb-3">Internship Certificates</h5>
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <input
                id="registrationId"
                type="text"
                className="form-control"
                placeholder="Enter your registration id"
                value={registrationId}
                onChange={(event) => setRegistrationId(event.target.value.toUpperCase())}
              />
            </div>

            {error && <div className="alert alert-danger py-2">{error}</div>}

            <button type="submit" className="btn btn-primary">
              View
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}


